import { createEntityAdapter } from '@reduxjs/toolkit';
import compareAsc from 'date-fns/compareAsc';

export const cartAdapter = createEntityAdapter({
  selectId: (item) => item.product,
  sortComparer: (a, b) => compareAsc(a.addedAt, b.addedAt),
});
